import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';
import { APP_FOOTER } from '../version';
import { landingPathFor } from '../utils/landing';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(email, password);
    setLoading(false);

    if (success === 'platform') {
      // Conta da plataforma: abre a consola (recarrega, para o contexto da consola ler a sessão que acabou de ser guardada).
      window.location.assign(landingPathFor('SuperAdmin'));
      return;
    }

    if (success) {
      // Cada papel entra no seu Dashboard (ver utils/landing.js): o Admin no do ginásio, os restantes no seu.
      let role = null;
      try { role = JSON.parse(localStorage.getItem('user') || '{}').role; } catch { /* sem dados: vai para o Dashboard */ }
      navigate(landingPathFor(role));
    }
  };

  return (
    <div className="auth-split-page">
      <div className="auth-split-left">
        <div className="auth-brand">
          <div className="auth-brand-icon"><img src="/gymag-icon.svg" alt="" width="88" height="88" /></div>
          <h1 className="auth-brand-name">GyMag</h1>
          <p className="auth-brand-tagline">Gestão Inteligente de Ginásios</p>
        </div>
        <div className="auth-features">
          <div className="auth-feature-card">
            <span className="auth-feature-icon">📅</span>
            <div>
              <div className="auth-feature-title">Agenda Avançada</div>
              <div className="auth-feature-desc">Gestão completa de marcações</div>
            </div>
          </div>
          <div className="auth-feature-card">
            <span className="auth-feature-icon">👥</span>
            <div>
              <div className="auth-feature-title">Gestão de Membros</div>
              <div className="auth-feature-desc">Perfil e histórico completo</div>
            </div>
          </div>
          <div className="auth-feature-card">
            <span className="auth-feature-icon">🏋️</span>
            <div>
              <div className="auth-feature-title">Planos de Treino</div>
              <div className="auth-feature-desc">Personalizados por membro</div>
            </div>
          </div>
          <div className="auth-feature-card">
            <span className="auth-feature-icon">🤖</span>
            <div>
              <div className="auth-feature-title">IA Integrada</div>
              <div className="auth-feature-desc">Análises e sugestões com IA</div>
            </div>
          </div>
        </div>
      </div>

      <div className="auth-split-right">
        <div className="auth-form-container">
        <div className="auth-mobile-brand"><img src="/gymag-icon.svg" alt="" width="44" height="44" /><span>GyMag</span></div>
          <h2 className="auth-form-title">Entrar</h2>
          <p className="auth-form-subtitle">Aceda à sua conta GyMag</p>

          <form onSubmit={handleSubmit} className="auth-form-inner">
            <div className="auth-field-group">
              <label className="auth-field-label">Email</label>
              <div className="auth-input-wrapper">
                <span className="auth-input-icon">✉</span>
                <input
                  type="email"
                  className="auth-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="o.seu@email.com"
                  required
                />
              </div>
            </div>

            <div className="auth-field-group">
              <label className="auth-field-label">Password</label>
              <div className="auth-input-wrapper">
                <span className="auth-input-icon">🔒</span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="auth-input auth-input-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••••"
                  required
                />
                <button
                  type="button"
                  className="auth-toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? '🙈' : '👁'}
                </button>
              </div>
            </div>

            <div className="auth-form-links">
              <Link to="/forgot-password" className="auth-link-small">Esqueceu a password?</Link>
            </div>

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? 'A entrar...' : 'Entrar'}
            </button>
          </form>

          <p className="auth-footer-text">{APP_FOOTER}</p>
        </div>
      </div>
    </div>
  );
}

export function Register() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await register(formData.name, formData.email, formData.password, formData.phone);
    setLoading(false);

    if (success) {
      navigate('/');
    }
  };

  return (
    <div className="auth-split-page">
      <div className="auth-split-left">
        <div className="auth-brand">
          <div className="auth-brand-icon"><img src="/gymag-icon.svg" alt="" width="88" height="88" /></div>
          <h1 className="auth-brand-name">GyMag</h1>
          <p className="auth-brand-tagline">Gestão Inteligente de Ginásios</p>
        </div>
        <div className="auth-features">
          <div className="auth-feature-card">
            <span className="auth-feature-icon">📅</span>
            <div>
              <div className="auth-feature-title">Agenda Avançada</div>
              <div className="auth-feature-desc">Gestão completa de marcações</div>
            </div>
          </div>
          <div className="auth-feature-card">
            <span className="auth-feature-icon">👥</span>
            <div>
              <div className="auth-feature-title">Gestão de Membros</div>
              <div className="auth-feature-desc">Perfil e histórico completo</div>
            </div>
          </div>
          <div className="auth-feature-card">
            <span className="auth-feature-icon">🏋️</span>
            <div>
              <div className="auth-feature-title">Planos de Treino</div>
              <div className="auth-feature-desc">Personalizados por membro</div>
            </div>
          </div>
          <div className="auth-feature-card">
            <span className="auth-feature-icon">🤖</span>
            <div>
              <div className="auth-feature-title">IA Integrada</div>
              <div className="auth-feature-desc">Análises e sugestões com IA</div>
            </div>
          </div>
        </div>
      </div>

      <div className="auth-split-right">
        <div className="auth-form-container">
        <div className="auth-mobile-brand"><img src="/gymag-icon.svg" alt="" width="44" height="44" /><span>GyMag</span></div>
          <h2 className="auth-form-title">Criar Conta</h2>
          <p className="auth-form-subtitle">Junte-se ao GyMag hoje</p>

          <form onSubmit={handleSubmit} className="auth-form-inner">
            <div className="auth-field-group">
              <label className="auth-field-label">Nome</label>
              <div className="auth-input-wrapper">
                <span className="auth-input-icon">👤</span>
                <input
                  type="text"
                  name="name"
                  className="auth-input"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="O seu nome"
                  required
                />
              </div>
            </div>

            <div className="auth-field-group">
              <label className="auth-field-label">Email</label>
              <div className="auth-input-wrapper">
                <span className="auth-input-icon">✉</span>
                <input
                  type="email"
                  name="email"
                  className="auth-input"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="o.seu@email.com"
                  required
                />
              </div>
            </div>

            <div className="auth-field-group">
              <label className="auth-field-label">Password</label>
              <div className="auth-input-wrapper">
                <span className="auth-input-icon">🔒</span>
                <input
                  type="password"
                  name="password"
                  className="auth-input"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••••"
                  required
                />
              </div>
            </div>

            <div className="auth-field-group">
              <label className="auth-field-label">Telefone (opcional)</label>
              <div className="auth-input-wrapper">
                <span className="auth-input-icon">📱</span>
                <input
                  type="tel"
                  name="phone"
                  className="auth-input"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+351 900 000 000"
                />
              </div>
            </div>

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? 'A criar conta...' : 'Registar'}
            </button>
          </form>

          <p className="auth-bottom-link">
            Já tem conta? <Link to="/login" className="auth-link">Entre aqui</Link>
          </p>

          <p className="auth-footer-text">{APP_FOOTER}</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
